import api, { publicApi } from './api';

const contactService = {
  /**
   * Enviar mensaje de contacto (PÚBLICO - sin autenticación)
   */
  async send(data) {
    try {
      const response = await publicApi.post('/contact', data);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al enviar el mensaje'
      };
    }
  },

  /**
   * Listar todos los mensajes (ADMIN)
   */
  async list(params = {}) {
    try {
      const response = await api.get('/contact/list', { params });
      return {
        success: true,
        data: response.data.data,
        pagination: response.data.pagination
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener mensajes'
      };
    }
  },

  /**
   * Obtener estadísticas de mensajes (ADMIN)
   */
  async getStats() {
    try {
      const response = await api.get('/contact/stats');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener estadísticas'
      };
    }
  },

  /**
   * Obtener mensaje por ID (ADMIN)
   * Marca automáticamente como "leído" si estaba en "nuevo"
   */
  async getById(id) {
    try {
      const response = await api.get(`/contact/${id}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener mensaje'
      };
    }
  },

  /**
   * Actualizar estado de un mensaje (ADMIN)
   */
  async updateStatus(id, data) {
    try {
      const response = await api.put(`/contact/${id}`, data);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar mensaje'
      };
    }
  },

  /**
   * Eliminar mensaje (ADMIN)
   */
  async delete(id) {
    try {
      const response = await api.delete(`/contact/${id}`);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al eliminar mensaje'
      };
    }
  }
};

export default contactService;

